import { ArrowsUpDownIcon, EyeIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { useTranslation } from 'react-i18next';

type SortOrder = 'oldest' | 'newest' | null;
type FilterType = 'most_viewed' | null;

interface DashboardControlsProps {
    sortOrder: SortOrder;
    filterType: FilterType;
    currentSlide: number;
    totalSlides: number;
    onSortClick: () => void;
    onMostViewedClick: () => void;
    onPrevSlide: () => void;
    onNextSlide: () => void;
}

export const DashboardControls: React.FC<DashboardControlsProps> = ({
    sortOrder,
    filterType,
    currentSlide,
    totalSlides,
    onSortClick,
    onMostViewedClick,
    onPrevSlide,
    onNextSlide,
}) => {
    const { t } = useTranslation('dashboard');

    return (
        <div className="flex items-center justify-end gap-2 mb-4">
            <span
                onClick={onSortClick}
                className={`inline-flex items-center gap-1 text-[10px] font-semibold cursor-pointer transition-all duration-200 ${sortOrder !== null
                        ? 'bg-blue-500 text-white rounded-md px-1 py-0.5'
                        : 'text-slate-600 hover:text-blue-600'
                    }`}
            >
                <ArrowsUpDownIcon className="w-3 h-3" />
                <span>
                    {sortOrder === null
                        ? t('sort')
                        : sortOrder === 'oldest'
                            ? t('oldest_first')
                            : t('newest_first')}
                </span>
            </span>

            <span
                onClick={onMostViewedClick}
                className={`inline-flex items-center gap-1 text-[10px] font-semibold cursor-pointer transition-all duration-200 ${filterType === 'most_viewed'
                        ? 'bg-green-500 text-white rounded-md px-1 py-0.5'
                        : 'text-slate-600 hover:text-green-600'
                    }`}
            >
                <EyeIcon className="w-3 h-3" />
                <span>{t('most_viewed')}</span>
            </span>

            <div className="flex items-center gap-1 ml-2">
                <button
                    onClick={onPrevSlide}
                    disabled={totalSlides <= 1}
                    className={`w-4 h-4 flex items-center justify-center text-slate-600 transition-all duration-200 ${totalSlides > 1
                            ? 'opacity-100 cursor-pointer hover:text-blue-700'
                            : 'opacity-30 cursor-not-allowed'
                        }`}
                    aria-label={t('scroll_left')}
                >
                    ←
                </button>

                <button
                    onClick={onNextSlide}
                    disabled={totalSlides <= 1}
                    className={`w-4 h-4 flex items-center justify-center text-slate-600 transition-all duration-200 ${totalSlides > 1
                            ? 'opacity-100 cursor-pointer hover:text-blue-700'
                            : 'opacity-30 cursor-not-allowed'
                        }`}
                    aria-label={t('scroll_right')}
                >
                    →
                </button>
            </div>
        </div>
    );
};